/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import * as Yup from "yup";

// Move the helper function above
const nameValidation = (
  max: number = Infinity,
  matches: RegExp = /.*/,
  required: boolean = false,
  message: string = "name"
) => {
  let schema = Yup.string()
    .max(max, `Maximum ${max} characters allowed in ${message}`)
    .matches(matches, `Only valid characters are allowed in ${message}`);

  if (required) {
    schema = schema.required(`${message} is required`);
  }

  return schema;
};

// Export the ingredient schema
export const ingredientSchema = Yup.object().shape({
  name: nameValidation(50, /^[a-zA-Z\s]+$/, true, "Ingredient Name"),
});
 export const categorySchema = Yup.object().shape({
  name: nameValidation(50, /^[a-zA-Z\s]+$/, true, "Category Name"),
  description:Yup.string(),
});
